import { createUseStyles } from 'react-jss';
import { color, spacing } from '@blink/components';

export const useManageStyle = createUseStyles({
    header: {
        display: 'flex',
        padding: `${spacing['08']} 10% 0px`,
        flexDirection: 'column',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    heading: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        alignSelf: 'stretch',
    },
    title: {
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        gap: spacing['03'],
    },
    titleText: {
        color: color.content.primary,
        fontSize: '24px',
        fontWeight: 600,
        lineHeight: '28px',
        letterSpacing: '-0.72px',
    },
    content: {
        display: 'flex',
        padding: '32px 10%',
        flexDirection: 'column',
        alignItems: 'flex-start',
        gap: 20,
        alignSelf: 'stretch',
    },
    description: {
        color: color.content.secondary,
        fontSize: 16,
        fontWeight: 400,
        lineHeight: '20px',
        letterSpacing: '-0.48px',
    },
});
